export default __webpack_public_path__ + "static/media/teams.23d1d865.mp3";